// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_3109c488"};